import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { useParams } from 'react-router-dom';
import { Button } from '../../../components';
import { BackIcon } from '../../../assets';
import { URLS, USER_ROLES } from '../../../constants/constants';
import { Navigation } from '../../../utils/navigation';
import { fetchUsersByOrganization } from '../../../store/users';
import styles from './index.module.css';

const statusLabel = {
  ACTIVE: 'Active',
  INVITED: 'Invited (Pending Activation)',
  EXPIRED: 'Invite Expired',
  DISABLED: 'Inactive',
};

const MultiSiteAdmins = ({ users, fetchUsersByOrganization }) => {
  const { id } = useParams();
  const navigate = Navigation();
  const admins = (users || []).filter((user) => user.role === USER_ROLES.HO_ADMIN);

  useEffect(() => {
    fetchUsersByOrganization({ id });
  }, [fetchUsersByOrganization, id]);

  return (
    <div className={styles.pageContent}>
      <div className={styles.header}>
        <div className={styles.titleRow}>
          <div className={styles.backBtn} onClick={() => navigate.back()}>
            <BackIcon width="26px" height="26px" fill="#E1F4D3" />
          </div>
          <h1 className={styles.pageTitle}>Multi-Site Admins</h1>
        </div>
        <Button onClick={() => navigate.push(URLS.CREATE_MULTI_SITE_ADMIN.replace(':id', id))}>
          Add Multi-Site Admin
        </Button>
      </div>
      <table className={styles.list}>
        <thead>
          <tr>
            <th>Name</th>
            <th>Email</th>
            <th>Status</th>
            <th>Facilities</th>
            <th />
          </tr>
        </thead>
        <tbody>
          {admins.map((admin) => (
            <tr key={admin.id}>
              <td>{admin.firstName} {admin.lastName}</td>
              <td>{admin.email}</td>
              <td>{statusLabel[admin.status] || admin.status}</td>
              <td>{(admin.permissions?.orgList || []).map((facility) => facility.name).join(', ')}</td>
              <td>
                <button
                  type="button"
                  className={styles.linkButton}
                  onClick={() => navigate.push(
                    URLS.EDIT_MULTI_SITE_ADMIN.replace(':id', id).replace(':userId', admin.id)
                  )}
                >
                  Edit facilities
                </button>
              </td>
            </tr>
          ))}
          {admins.length === 0 && (
            <tr>
              <td colSpan={5}>No multi-site admins on this enterprise yet.</td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

const mapStateToProps = (state) => ({
  users: state.users.users,
});

const mapDispatchToProps = (dispatch) => bindActionCreators({ fetchUsersByOrganization }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(MultiSiteAdmins);
